module.exports = __webpack_public_path__ + "img/customers_icon_pink.e725dd6b.svg";